import { render, staticRenderFns } from "./UICouponUses.vue?vue&type=template&id=30f8ea2e&"
import script from "./UICouponUses.vue?vue&type=script&lang=js&"
export * from "./UICouponUses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports